import nprogress from 'nprogress';

export async function LazyLoadRoute(view: Promise<any>) {
    nprogress.start();
    const page = await view;
    nprogress.done();
    return page;
}